import React, { Component } from "react";
import cn from "classnames";
import PropTypes from "prop-types";

import RadioUnchecked from "../../../containers/assets/radio-unchecked.svg";
import RadioChecked from "../../../containers/assets/radio-checked.svg";

class TeamTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedValues: props.values
    };
  }

  componentDidMount() {
    const img1Preload = new Image();
    img1Preload.src = RadioUnchecked;

    const img2Preload = new Image();
    img2Preload.src = RadioChecked;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { id, values } = this.props;

    if (prevProps.id !== id) {
      this.setState(() => ({ selectedValues: values }));
    }
  }

  isCheckboxSelected = (teammate, value) => {
    const { selectedValues } = this.state;
    const { feedbacks } = this.props;

    const feedback = feedbacks[teammate.id];
    if (!feedback) {
      return false;
    }

    const answer = selectedValues.find(i => i.feedback === feedback.id);
    if (!answer) {
      return false;
    }

    return typeof answer.value === "string" && answer.value.toLowerCase() === value;
  }

  handleOnSelect = (teammate, value) => {
    const { selectedValues } = this.state;
    const { feedbacks, readonlyMode } = this.props;

    if (readonlyMode) {
      return;
    }

    const feedback = feedbacks[teammate.id];
    if (!feedback) {
      return;
    }

    const newValues = [...selectedValues];
    let answerIndex = newValues.findIndex(i => i.feedback === feedback.id);
    let stateChanged = false;
    if (answerIndex === -1) {
      newValues.push({
        feedback: feedback.id,
        value,
      });
      stateChanged = true;
    } else if (answerIndex >= 0 && (typeof newValues[answerIndex].value !== "string" || newValues[answerIndex].value.toLowerCase() !== value)) {
      newValues[answerIndex].value = value;
      stateChanged = true;
    }

    if (stateChanged) {
      this.setState({
        selectedValues: newValues,
      }, () => {
        const { onChange, id } = this.props;

        if (onChange) {
          onChange({
            id,
            value,
            type: "likert",
            hasError: false,
            feedback: feedback.id,
          });
        }
      });
    }
  };

  render() {
    const { title, teamList, readonlyMode } = this.props;

    return (
      <div className="teamTable">
        <div className="title">{title}</div>
        <div className="teamTableWrapper">
          <table>
            <tbody>
            <tr className="teamTableHeader">
              <th></th>
              <th className="teamTableCheckboxColumn">Yes</th>
              <th className="teamTableCheckboxColumn">No</th>
              <th className="teamTableEmptyColumn"></th>
            </tr>
            {teamList.map((teammate, teammateIndex) => (
              <tr key={`team-table-row-${teammateIndex}`} className={cn({
                teamTableGrayRow: teammateIndex % 2 === 0
              })}>
                <td className="teamTableUserName">{teammate.fullname}</td>
                <td className="teamTableCheckboxColumn">
                  <div className={cn("teamTableCheckbox", {
                    teamTableCheckbox_selected: this.isCheckboxSelected(teammate, "yes"),
                    teamTableCheckbox_nofocus: readonlyMode,
                  })}>
                    <img
                      alt="radio-unchecked"
                      src={RadioUnchecked}
                      className="unchecked"
                      onClick={() => this.handleOnSelect(teammate, "yes")}
                    />
                    <img
                      alt="radio-checked"
                      src={RadioChecked}
                      className="checked"
                      onClick={() => this.handleOnSelect(teammate, "yes")}
                    />
                  </div>
                </td>
                <td className="teamTableCheckboxColumn">
                  <div className={cn("teamTableCheckbox", {
                    teamTableCheckbox_selected: this.isCheckboxSelected(teammate, "no"),
                    teamTableCheckbox_nofocus: readonlyMode,
                  })}>
                    <img
                      alt="radio-unchecked"
                      src={RadioUnchecked}
                      className="unchecked"
                      onClick={() => this.handleOnSelect(teammate, "no")}
                    />
                    <img
                      alt="radio-checked"
                      src={RadioChecked}
                      className="checked"
                      onClick={() => this.handleOnSelect(teammate, "no")}
                    />
                  </div>
                </td>
                <td className="teamTableEmptyColumn"></td>
              </tr>
            ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

TeamTable.propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.shape({
    feedback: PropTypes.number,
    value: PropTypes.string,
  })),
  onChange: PropTypes.func,
  teamList: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    fullname: PropTypes.string,
  })),
  readonlyMode: PropTypes.bool,
};

export default TeamTable;



// WEBPACK FOOTER //
// ./src/components/peer-evaluation/team-table/index.js